<template>
  <div class="manage-page">
    <!-- 搜索区域 -->
    <el-form :inline="true" :model="query" size="small">
      <el-form-item label="型号">
        <el-select v-model="query.model" placeholder="全部" clearable style="width:160px;">
          <el-option v-for="m in modelList" :key="m" :label="m" :value="m" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期">
        <el-date-picker v-model="query.startDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:160px;" />
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker v-model="query.endDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:160px;" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table :data="tableData" border stripe v-loading="loading" style="width:100%;">
      <el-table-column prop="model" label="型号" width="120" />
      <el-table-column prop="firstSerialNumber" label="起始序列号" width="180" />
      <el-table-column prop="lastSerialNumber" label="结束序列号" width="180" />
      <el-table-column prop="productionTime" label="生产时间" min-width="160" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <div style="display:flex;flex-direction:column;gap:6px;">
            <el-button type="primary" size="mini" @click="openReprint(scope.row, 'nameplate')">铭牌标签</el-button>
            <el-button type="warning" size="mini" @click="openReprint(scope.row, 'batch')">补打批次</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top:20px;text-align:right;"
      :current-page="query.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="query.pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next"
      @size-change="(v) => { query.pageSize = v; fetchData() }"
      @current-change="(v) => { query.pageNum = v; fetchData() }"
    />

    <!-- 补打弹窗 -->
    <el-dialog :title="reprintTitle" :visible.sync="reprintVisible" width="400px" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="开始批次号">
          <el-input v-model="reprintStart" placeholder="请输入开始批次号" />
        </el-form-item>
        <el-form-item label="结束批次号">
          <el-input v-model="reprintEnd" placeholder="请输入结束批次号" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="reprintVisible = false">取消</el-button>
        <el-button type="primary" round @click="confirmReprint">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'

export default {
  name: 'foreignTrade_manage',
  data() {
    return {
      loading: false,
      allModelData: [],
      modelList: [],
      query: {
        model: '',
        startDate: '',
        endDate: '',
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
      reprintVisible: false,
      reprintType: '',
      reprintTitle: '',
      currentRow: {},
      reprintStart: '',
      reprintEnd: ''
    }
  },
  mounted() {
    this.$api.getAllModelInfo().then(res => {
      if (res.code === 200 && res.data) {
        this.allModelData = res.data
        this.modelList = res.data.map(item => item.model)
      }
    })
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize
      }
      if (this.query.model) params.model = this.query.model
      if (this.query.startDate) params.startDate = this.query.startDate
      if (this.query.endDate) params.endDate = this.query.endDate
      this.$api.getFtDeviceRecordPage(params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data.list || []
          this.total = res.data.totalNum || 0
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.query.pageNum = 1
      this.fetchData()
    },
    handleReset() {
      this.query = { model: '', startDate: '', endDate: '', pageNum: 1, pageSize: 10 }
      this.fetchData()
    },
    openReprint(row, type) {
      this.currentRow = row
      this.reprintType = type
      this.reprintTitle = type === 'nameplate' ? '打印铭牌标签' : '补打批次标签'
      this.reprintStart = row.firstSerialNumber
      this.reprintEnd = row.lastSerialNumber
      this.reprintVisible = true
    },
    confirmReprint() {
      const row = this.currentRow
      const prefix = row.firstSerialNumber.substring(0, 8)
      const startNum = parseInt(row.firstSerialNumber.substring(8), 10)
      const endNum = parseInt(row.lastSerialNumber.substring(8), 10)
      const inpStart = parseInt(this.reprintStart.substring(8), 10)
      const inpEnd = parseInt(this.reprintEnd.substring(8), 10)

      if (this.reprintStart.substring(0, 8) !== prefix || this.reprintEnd.substring(0, 8) !== prefix) {
        this.$message.error(`编号前8位必须为 ${prefix}`)
        return
      }
      if (inpStart < startNum || inpEnd > endNum) {
        this.$message.error(`编号后4位必须在 ${row.firstSerialNumber} ~ ${row.lastSerialNumber} 之间`)
        return
      }
      const count = inpEnd - inpStart + 1
      if (count <= 0) {
        this.$message.error('结束批次号必须大于等于开始批次号')
        return
      }
      this.reprintVisible = false
      if (this.reprintType === 'nameplate') {
        this.doNameplatePrint(row.model, this.reprintStart, count)
      } else {
        this.doBatchReprint(row.model, this.reprintStart, count)
      }
    },
    // ====== 铭牌标签打印 ======
    async doNameplatePrint(model, startBatch, count) {
      const LODOP = this.getLodop()

      if (!LODOP) { this.$message.warning('请先安装Lodop打印控件'); return }
      const d = this.allModelData.find(m => m.model === model) || {}
      const LOGO_URL = 'https://chiffo-cloud-1253199270.cos.ap-chengdu.myqcloud.com/gassafetysystem/foreigntrade/neo_log.png'
      const startNum = parseInt(startBatch, 10)
      LODOP.SET_LICENSES('', '', '', '')
      LODOP.SET_PRINT_PAGESIZE(2, 93, 58, 'LBL95x60')
      LODOP.SET_PRINT_MODE('CUSTOM_PAGE_NAME', 'LBL95x60')
      LODOP.SET_PRINT_MODE('PAGE_MARGIN_TOP', '0mm')
      LODOP.SET_PRINT_MODE('PAGE_MARGIN_BOTTOM', '0mm')
      LODOP.PRINT_INITA('0mm', '0mm', '95mm', '60mm', '铭牌标签')
      LODOP.SET_SHOW_MODE('PREVIEW_IN_BROWSE', 1)
      LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 0, 0, '')
      for (let i = 0; i < count; i++) {
        const batchNo = String(startNum + i)
        const barcodeUrl = await this.barcodeToDataUrl(batchNo)
        if (i > 0) LODOP.NewPage()
        const html = `<div style="border:1px solid #333;width:100%;height:100%;box-sizing:border-box;">
          <div style="height:7mm;border-bottom:1px solid #333;display:flex;">
            <div style="width:20mm;border-right:1px solid #333;display:flex;align-items:center;justify-content:center;">
              <img src="${LOGO_URL}" style="width:14.5mm;height:auto;">
            </div>
            <div style="flex:1;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:600;font-family:Arial,sans-serif;">Электрический одноконтурный котел</div>
          </div>
        <table style="width:100%; height:25mm; border-collapse:collapse; table-layout:fixed;">
    <!-- 第一行 -->
    <tr>
        <!-- 关键修改：给左侧TD添加 padding-left:3mm 和 vertical-align:middle -->
        <td style="font-weight:600;border-bottom:1px solid #333; border-right:1px solid #333; width:60%; padding-left:3mm; vertical-align:middle; font-family:Arial,sans-serif;">Модель</td>
        <td style="font-family:Arial,sans-serif;font-weight:600;border-bottom:1px solid #333; width:40%; text-align:center; vertical-align:middle;">${d.model || model}</td>
    </tr>
    <!-- 第二行 -->
    <tr>
        <td style="font-weight:600;border-bottom:1px solid #333; border-right:1px solid #333; padding-left:3mm; vertical-align:middle; font-family:Arial,sans-serif;">Электропитание</td>
        <td style="font-family:Arial,sans-serif;font-weight:600;border-bottom:1px solid #333; text-align:center; vertical-align:middle;">${d.ratedVoltage || '-'}</td>
    </tr>
    <!-- 第三行 -->
    <tr>
        <td style="font-weight:600;border-bottom:1px solid #333; border-right:1px solid #333; padding-left:3mm; vertical-align:middle; font-family:Arial,sans-serif;">Мощность</td>
        <td style="font-weight:600;font-family:Arial,sans-serif;border-bottom:1px solid #333; text-align:center; vertical-align:middle;">${d.power || '-'}</td>
    </tr>
    <!-- 第四行 -->
    <tr>
        <td style="font-weight:600;border-bottom:1px solid #333; border-right:1px solid #333; padding-left:3mm; vertical-align:middle; font-family:Arial,sans-serif;">Класс водозащиты</td>
        <td style="font-weight:600;font-family:Arial,sans-serif;border-bottom:1px solid #333; text-align:center; vertical-align:middle;">IPX4</td>
    </tr>
     <tr>
        <td style="font-weight:600;border-right:1px solid #333; padding-left:3mm; vertical-align:middle; font-family:Arial,sans-serif;">Класс электрозащиты</td>
        <td style="font-weight:600;font-family:Arial,sans-serif;text-align:center; vertical-align:middle;">I</td>
    </tr>
</table>
          <div style="height:15mm;border-top:1px solid #333;font-size:14px;font-weight:600;color:#000;font-family:Arial,sans-serif;">
            <div style="text-align:left;padding:1px 0 0 3mm;">Серийный номер:</div>
            <div style="text-align:center;padding-left:40mm;margin-top: -3mm;">
              <img src="${barcodeUrl}" style="width:65%;height:10mm;">
              <div>${batchNo}</div>
            </div>
          </div>
        </div>`
        LODOP.ADD_PRINT_HTM('2mm', '1mm', '93mm', '59mm', html)
        LODOP.SET_PRINT_STYLEA(0, 'Stretch', 1)
      }
      LODOP.PREVIEW()
    },
    // ====== 批次补打逻辑 ======
    getLodop() {
      var LODOP
      try { LODOP = new ActiveXObject('CLodop.1'); return LODOP } catch (e) {}
      try { LODOP = new ActiveXObject('Lodop.1'); return LODOP } catch (e) {}
      try { LODOP = new ActiveXObject('LODOP.Print'); return LODOP } catch (e) {}
      if (typeof window.getCLodop !== 'undefined') {
        LODOP = window.getCLodop()
        if (LODOP) return LODOP
      }
      LODOP = document.getElementById('LODOP_OB')
      if (LODOP && typeof LODOP.SET_PRINT_PAGESIZE === 'function') return LODOP
      var embed = document.createElement('embed')
      embed.id = 'LODOP_OB'
      embed.type = 'application/x-print-lodop'
      embed.width = 0; embed.height = 0
      embed.style.cssText = 'position:absolute;left:-100px;top:-100px;'
      document.body.appendChild(embed)
      return embed && typeof embed.SET_PRINT_PAGESIZE === 'function' ? embed : null
    },
    barcodeToDataUrl(batchNo) {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas')
        canvas.width = 320; canvas.height = 30
        JsBarcode(canvas, batchNo, { format: 'CODE128', width: 1, height: 24, displayValue: false, margin: 2 })
        resolve(canvas.toDataURL('image/png'))
      })
    },
    generateQRDataUrl(batchNo) {
      return new Promise((resolve) => {
        const url = `https://www.chiffoele.com/GasSafetySystem/foreigntrade/getProductionInfoByQrcode?model=${encodeURIComponent(this.currentRow.model)}&serialNumber=${batchNo}`
        QRCode.toDataURL(url, { width: 256 }, (err, dataUrl) => { resolve(err ? '' : dataUrl) })
      })
    },
    printLabel(LODOP, top, left, width, height, batchNo, barcodeUrl, modelData) {
      const d = this.allModelData.find(m => m.model === modelData) || {}
      const colW = '50%'
      const dateStr = (batchNo || '').substring(0, 8)
      const td = 'padding:0 1px;text-align:center;font-size:14px;font-weight:600;color:#000;font-family:Arial,sans-serif;'
      const html = `<table style="border-collapse:collapse;width:100%;height:100%;">` +
        `<tr style="font-weight:bold;height:16px;"><td style="${td}border:1px solid #333;">Модель: ${d.model || modelData}</td><td style="${td}border:1px solid #333;">Тип продукта: электрический одноконтурный котёл</td></tr>` +
        `<tr><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Диапазон температур: ${d.temperatureRange || '-'}</td><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Размер короба: ${d.boxSpecifications || '-'}</td></tr>` +
        `<tr><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Электропитание: ${d.ratedVoltage || '-'}</td><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Вес HETTO: ${d.netWeight || '-'}</td></tr>` +
        `<tr><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Мощность: ${d.power || '-'}</td><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Вес БРУТТО: ${d.grossWeight || '-'}</td></tr>` +
        `<tr><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Дата производства:</td><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">Серийный номер:</td></tr>` +
        `<tr><td style="${td}border-left:1px solid #333;border-right:1px solid #333;">${dateStr}</td><td style="${td}border-left:1px solid #333;border-right:1px solid #333;"><img src="${barcodeUrl}"></td></tr>` +
        `<tr><td style="${td}border-left:1px solid #333;border-right:1px solid #333;border-bottom:1px solid #333;"></td><td style="${td}border-left:1px solid #333;border-right:1px solid #333;border-bottom:1px solid #333;">${batchNo}</td></tr>` +
        `</table>`
      LODOP.ADD_PRINT_HTM(top + 'mm', left + 'mm', width + 'mm', height + 'mm', html)
      LODOP.SET_PRINT_STYLEA(0, 'Stretch', 1)
    },
    async doBatchReprint(model, startBatch, count) {
      const LODOP = this.getLodop()
      if (!LODOP) { this.$message.warning('请先安装Lodop打印控件'); return }
      const startNum = parseInt(startBatch, 10)
      LODOP.SET_LICENSES('', '', '', '')
      LODOP.SET_PRINT_PAGESIZE(2, 290, 60, 'LBL290x60')
      LODOP.SET_PRINT_MODE('CUSTOM_PAGE_NAME', 'LBL290x60')
      LODOP.SET_PRINT_MODE('PAGE_MARGIN_TOP', '0mm')
      LODOP.SET_PRINT_MODE('PAGE_MARGIN_BOTTOM', '0mm')
      LODOP.PRINT_INITA('0mm', '0mm', '290mm', '60mm', '补打标签')
      LODOP.SET_SHOW_MODE('PREVIEW_IN_BROWSE', 1)
      LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 0, 0, '')
      for (let i = 0; i < count; i++) {
        const batchNo = String(startNum + i)
        const barcodeUrl = await this.barcodeToDataUrl(batchNo)
        const qrDataUrl = await this.generateQRDataUrl(batchNo)
        if (i > 0) LODOP.NewPage()
        this.printLabel(LODOP, 5, 10, 88, 54, batchNo, barcodeUrl, model)
        this.printLabel(LODOP, 5, 125, 88, 54, batchNo, barcodeUrl, model)
        const copy3Html = `<div style="text-align:center;padding-top:2mm;">
          <img src="${qrDataUrl}" style="width:24mm;height:24mm;">
          <span style="font-size:14px;font-weight:600;color:#000;font-family:Arial,sans-serif;display:block;margin-top:2.5mm;">${batchNo}</span>
        </div>`
        LODOP.ADD_PRINT_HTM('0mm', '231mm', '50mm', '60mm', copy3Html)
      }
      LODOP.PREVIEW()
    }
  }
}
</script>

<style scoped>
.manage-page {
  padding: 20px;
}
</style>
